import axios from './axios_config';

export const getHelpItem = async () => {
    // console.log(`SESSION STORAGE`, sessionStorage.getItem('accessToken'));
    let result = await axios.get('/api/v1/generic/help-item/');
    return result;
};

export const createHelpItem = async (name, parent) => {
    // console.log(`SESSION STORAGE`, sessionStorage.getItem('accessToken'));
    let result = await axios.post('/api/v1/generic/help-item/', {
        name: name,
        parent: [parent]
    });
    return result;
};

export const deleteHelpItem = async (idToRemove) => {
    // console.log(`SESSION STORAGE`, sessionStorage.getItem('accessToken'));
    let result = await axios.delete(`/api/v1/generic/help-item/${idToRemove}/`);
    return result;
};

export const getHelpContentToNav = async () => {
    // console.log(`SESSION STORAGE`, sessionStorage.getItem('accessToken'));
    let result = await axios.get(`/api/v1/generic/help-content/`);
    return result;
};

export const getHelpContent = async (helpItem) => {
    // console.log(`SESSION STORAGE`, sessionStorage.getItem('accessToken'));
    let result = await axios.get(
        `/api/v1/generic/help-content/?help_item=${helpItem}`
    );
    return result;
};

export const setHelpContentOrder = async (topicId, order) => {
    // console.log(`SESSION STORAGE`, sessionStorage.getItem('accessToken'));
    let result = await axios.post('/api/v1/generic/help-content/order/', {
        help_item: topicId,
        order: order
    });
    return result;
};

// export const getHelpContentId = async (id) => {
//     // console.log(`SESSION STORAGE`, sessionStorage.getItem('accessToken'));
//     let result = await axios.get(`/api/v1/generic/help-content/${id}/`);
//     console.log(`getHelpContentId`, result);
//     return result;
// };

// getHelpContentId(39);

export const createHelpContent = async (
    helpItem,
    title,
    image,
    description
) => {
    // console.log(`SESSION STORAGE`, sessionStorage.getItem('accessToken'));
    let result = await axios.post('/api/v1/generic/help-content/', {
        description: description,
        help_item: helpItem,
        title: title,
        image: image
    });
    return result;
};

export const editHelpContent = async (id, title, description) => {
    // console.log(`SESSION STORAGE`, sessionStorage.getItem('accessToken'));
    let result = await axios.patch(`/api/v1/generic/help-content/${id}/`, {
        title: title,
        description: description
    });
    return result;
};

// editHelpContent(5);

export const deleteHelpContent = async (id) => {
    // console.log(`SESSION STORAGE`, sessionStorage.getItem('accessToken'));
    let result = await axios.delete(`/api/v1/generic/help-content/${id}/`);

    console.log(`I delete content id: ${id}`);
    return result;
};

export const editHelpItem = async (idproject, parentId, name) => {
    // console.log(`SESSION STORAGE`, sessionStorage.getItem('accessToken'));
    let result = await axios.patch(`/api/v1/generic/help-item/${idproject}/`, {
        name: name,
        parent: parentId,
        order: idproject
    });
    return result;
};

// deleteHelpItem(7);

// createHelpContent(
//     6,
//     'test title 10',
//     'https://excludefrombackuptestbucket.s3.amazonaws.com/devbucket/econometrica/help/2/Screenshot_2022-07-20_at_16.59.15_1659626695.png?AWSAccessKeyId=AKIAVQHYWSBUTNRAURRI&Signature=PK0E0HYhUPOMZ9lbDKO4O6pFD2Y%3D&Expires=1659712808',
//     'sss'
// );
// export const createHelpContent = async (name, parentId) => {
//     // console.log(`SESSION STORAGE`, sessionStorage.getItem('accessToken'));
//     let result = await axios.get('/api/v1/generic/help-content/', {
//         name: name,
//         parent: parentId
//     });
//     return result;
// };

// export const createHelpContent = async (name, parentId, order) => {
//     // console.log(`SESSION STORAGE`, sessionStorage.getItem('accessToken'));
//     let result = await axios.post('/api/v1/generic/help-content/', {
//         name: name,
//         parent: parentId,
//         order: order
//     });
//     return result;
// };
// DeleteHelpItem(6, 2);
// DeleteHelpItem(5);
export const getGlossaryTerm = async () => {
    // console.log(`SESSION STORAGE`, sessionStorage.getItem('accessToken'));
    let result = await axios.get('/api/v1/generic/glossary-item/');
    return result;
};

export const createGlossaryTerm = async (name, description) => {
    // console.log(`SESSION STORAGE`, sessionStorage.getItem('accessToken'));
    let result = await axios.post('/api/v1/generic/glossary-item/', {
        term: name,
        description: description
    });
    return result;
};

export const updateGlossaryTerm = async (id, name, description) => {
    // console.log(`SESSION STORAGE`, sessionStorage.getItem('accessToken'));
    let result = await axios.patch(`/api/v1/generic/glossary-item/${id}/`, {
        term: name,
        description: description
    });
    return result;
};

export const deleteGlossaryTerm = async (idToRemove) => {
    // console.log(`SESSION STORAGE`, sessionStorage.getItem('accessToken'));
    let result = await axios.delete(`/api/v1/generic/glossary-item/${idToRemove}/`);
    return result;
};
